import Fetch, { V1 } from 'Util/fetcher';

const ON_REQUEST_MF_PAYMENT_METHOD = 'ON_REQUEST_MF_PAYMENT_METHOD';
const ON_REQUEST_MF_PAYMENT_METHOD_FAILURE = 'ON_REQUEST_MF_PAYMENT_METHOD_FAILURE';
const ON_REQUEST_MF_PAYMENT_METHOD_SUCCESS = 'ON_REQUEST_MF_PAYMENT_METHOD_SUCCESS';
function onRequestMfPaymentMethod() {
  return {
    type: ON_REQUEST_MF_PAYMENT_METHOD,
  };
}
function onRequestMfPaymentMethodSuccess(payload) {
  return {
    type: ON_REQUEST_MF_PAYMENT_METHOD_SUCCESS,
    payload,
  };
}
function onRequestMfPaymentMethodFailure(payload) {
  return {
    type: ON_REQUEST_MF_PAYMENT_METHOD_FAILURE,
    payload,
  };
}
export const onDoRequestMfPaymentMethod = payload => (dispatch) => {
  dispatch(onRequestMfPaymentMethod());
  Fetch.get(
    `${V1}mutualfund/payment/inquiry-channel/?type=THEME&fund_id=${payload}`
  )
    .then((resp) => {
      if (resp.ok) {
        dispatch(onRequestMfPaymentMethodSuccess(resp.json));
      } else {
        dispatch(onRequestMfPaymentMethodFailure(resp.json));
      }
    })
    .catch((error) => {
      dispatch(onRequestMfPaymentMethodFailure(error.message));
    });
};

const INITIAL_STATE = {
  paymentMethodLoading: false,
  paymentMethodData: null,
  paymentMethodError: null,
};

const paymentMethod = (state = INITIAL_STATE, { type, payload } = {}) => {
  switch (type) {
    case ON_REQUEST_MF_PAYMENT_METHOD:
      return {
        ...state,
        paymentMethodLoading: true,
        paymentMethodError: null,
      };
    case ON_REQUEST_MF_PAYMENT_METHOD_SUCCESS:
      return {
        ...state,
        paymentMethodLoading: false,
        paymentMethodData: payload,
        paymentMethodError: null,
      };
    case ON_REQUEST_MF_PAYMENT_METHOD_FAILURE:
      return {
        ...state,
        paymentMethodLoading: false,
        paymentMethodError: payload,
      };

    default:
      return state;
  }
};

export default paymentMethod;
